import React, { FC } from 'react'
import styled from 'styled-components'

import InfinityObserver from 'components/Observer/InfinityObserver'
import { ISection } from '../../interfaces'
import { ButtonStyled, Title } from '../CssStyled'
import ExpansionPanel from './ExpansionPanel'
import Link from '@ads/front-core/atoms/Link'
import TrustedUs from './TrustedUs'
import { breakpoints } from '@ads/front-core/constants/breakpoints'
import { Trans, lng } from '@ads/front-core/locales'

const MorePossibilities: FC<ISection> = ({ setActiveMenu }) => (
  <InfinityObserver callback={() => setActiveMenu('more-possibilities')}>
    <Container>
      <TitleWrapper>
        <Title color="inverted100">
          <Trans
            i18nKey="landing:discoverMorePossibilities"
            components={{
              bold: <Title bold color="inverted100" />,
            }}
          />
        </Title>
      </TitleWrapper>
      <Possibilities>
        <ExpansionPanel label={lng('landing:knoweleadgeAboutUser')}>
          <Trans
            i18nKey="landing:knoweleadgeAboutUserDescription"
            components={{
              additionalInfo: <AdditionalInfo />,
            }}
          />
        </ExpansionPanel>
        <ExpansionPanel label={lng('landing:inteligentSalesBoosterCampaigns')}>
          {lng('landing:inteligentSalesBoosterCampaignsDescription')}
        </ExpansionPanel>
        <ExpansionPanel label={lng('landing:wpPartnerPartners')}>
          {lng('landing:wpPartnerPartnersDescription')}
        </ExpansionPanel>
        <ExpansionPanel label={lng('landing:metricsAnalytics')}>
          {lng('landing:metricsAnalyticsDescription')}
        </ExpansionPanel>
        <ExpansionPanel label={lng('landing:wpPixel')}>
          {lng('landing:wpPixelDescription')}
        </ExpansionPanel>
      </Possibilities>

      <ButtonGetStarted to="/1login/">
        <Trans
          i18nKey="landing:runYourFirstCampaign"
          components={{
            textFirst: <TextFirst />,
            buttonTextLighter: <ButtonTextLighter />,
          }}
        />
      </ButtonGetStarted>

      <TrustedUs />
    </Container>
  </InfinityObserver>
)

const Container = styled.div`
  position: relative;
  padding: 24px 0 90px;

  &::before {
    content: '';
    position: absolute;
    left: 50%;
    right: 50%;
    width: 100vw;
    margin-left: -50vw;
    margin-right: -50vw;
    bottom: 0;
    top: 0;
    background-color: #262a44;
    z-index: -1;
  }
`

const TitleWrapper = styled.div`
  margin-bottom: 40px;
`

const Possibilities = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
`

const AdditionalInfo = styled.div`
  margin-top: 32px;
`

export const ButtonGetStarted = styled(Link)`
  ${ButtonStyled}
  margin: 52px auto 0;
`

const ButtonTextLighter = styled.span`
  display: contents;
  font-weight: lighter;
  font-size: 18px;

  @media (max-width: ${breakpoints.MOBILE}) {
    display: none;
  }
`

const TextFirst = styled.span`
  display: contents;

  @media (max-width: ${breakpoints.MOBILE}) {
    display: none;
  }
`

export default MorePossibilities
